import { render, staticRenderFns } from "./box_shadow.vue?vue&type=template&id=6cfe8a84&"
import script from "./box_shadow.vue?vue&type=script&lang=js&"
export * from "./box_shadow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports